import React, { Component } from 'react';

import { ClickableComponent } from '@schoolinks/ui-components';
import cn from 'classnames';
import { isEqual, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { withState } from 'recompose';

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faHouse } from '@fortawesome/pro-regular-svg-icons/faHouse';
import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons/faLockKeyhole';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import Collapse from '@mui/material/Collapse';
import Drawer from '@mui/material/Drawer';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import {
  MENU_ICON_MAP,
  MENU_ICON_MAP_ENH,
  MENU_ICON_LINK_MAP,
  NAV_LINK_MAP,
} from 'components/Common/LayoutV2/constants';
import ResponsivePrompt from 'components/Common/LayoutV2/SideNav/MobileSideNav/ResponsivePrompt';
import {
  getRelevantNavItems,
  getHiddenNavItem,
} from 'components/Common/LayoutV2/utils';
import withRouter from 'containers/withRouter';
import withUserTypeAndOrgInfo from 'containers/withUserTypeAndOrgInfo';
import withModal from 'HOC/withModal';
import ModalPropTypes, { ModalDefaultProps } from 'propTypes/ModalPropTypes';
import { RouterPropTypes } from 'propTypes/RouterPropTypes';

import { NEWSFEED, ORG } from 'routes/constants';
import { ensureArray } from 'utils/arrays';

import v from 'components/variables';

import s from './MobileSideNav.css';

@withRouter
@withUserTypeAndOrgInfo
@withModal
@connect(
  ({ user: { layout = {}, type = [], currentUserMode } = {} }) => ({
    sideNav: getRelevantNavItems(layout, type, 'sideNav', currentUserMode),
  }),
  null,
)
@withState('openMenuIndex', 'setOpenMenuIndex', null)
@withState('possiblePush', 'setPossiblePush', null)
export default class MobileSideNav extends Component {
  shouldComponentUpdate(nextProps, nextStates) {
    return !isEqual(nextProps, this.props) || !isEqual(nextStates, this.state);
  }

  onMobileCancel = () => {
    const { setPossiblePush } = this.props;
    setPossiblePush(null);
  };

  goToRoute = route => {
    const { push } = this.props;
    push(route);
  };

  toggleMenu = key => {
    const { openMenuIndex, setOpenMenuIndex } = this.props;
    const updatedIndex = key === openMenuIndex ? null : key;
    setOpenMenuIndex(updatedIndex);
  };

  render() {
    const {
      router: { location: { pathname } = {}, navigate, match },
      user,
      sideNav,
      appbarOpen,
      toggleAppbar = () => null,
      color,
      showModal,
      openMenuIndex,
      possiblePush,
    } = this.props;

    const baseNav = sideNav?.find(el => el.type === 'base');
    const orgNav = sideNav?.find(el => el.type === 'org_member');
    const { selectedOrganizationUuid, isMember } = user;

    return (
      <>
        {possiblePush && <ResponsivePrompt onCancel={this.onMobileCancel} />}
        <Drawer
          anchor="left"
          open={!possiblePush && appbarOpen}
          onClose={toggleAppbar}
          classes={{
            paper: s.drawerPaper,
          }}
          PaperProps={{
            style: { backgroundColor: v[`${color}Dark`] },
          }}
        >
          <div className={s.header}>
            <ClickableComponent
              aria-label="Toggle app bar"
              className={s.closeIcon}
              onClick={toggleAppbar}
            >
              <FontAwesomeIcon icon={faXmark} />
            </ClickableComponent>
          </div>

          <div className={s.menuContainer}>
            {isMember && (
              <ClickableComponent
                key="home"
                onClick={() => {
                  if (!pathname.startsWith(NEWSFEED)) navigate(NEWSFEED);
                }}
                className={cn(s.menuItem, {
                  [s.activeMenuItem]: pathname.startsWith('/newsfeed'),
                })}
              >
                <div className={s.menuItemChildren}>
                  <div className={s.flexCenter}>
                    <div className={s.menuIcon}>
                      <FontAwesomeIcon icon={faHouse} />
                    </div>
                    <div className={s.menuTitle}>Home</div>
                  </div>
                </div>
              </ClickableComponent>
            )}
            {orgNav &&
              orgNav.items.map(menu => {
                const { organizationUuid } = menu;
                const isMenuActive =
                  selectedOrganizationUuid === organizationUuid;
                const { key, organizationName, menuOptions } = menu;

                return (
                  <div
                    key={key}
                    className={cn(s.menuItem, {
                      [s.activeMenuItem]: isMenuActive,
                    })}
                  >
                    <div
                      className={s.menuItemChildren}
                      {...((menuOptions || []).length
                        ? {
                            role: 'button',
                            tabIndex: 0,
                            onClick: () => this.toggleMenu(key),
                          }
                        : {})}
                    >
                      <div className={s.flexCenter}>
                        <div
                          className={s.orgImg}
                          style={{ backgroundImage: `url(${menu.img})` }}
                        />
                        <div
                          className={cn(s.menuTitle, {
                            [s.menuTitleExpanded]: openMenuIndex === key,
                          })}
                        >
                          {organizationName}
                        </div>
                      </div>

                      {(menuOptions || []).length ? (
                        <div className={s.menuToggleIcon}>
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            rotation={openMenuIndex === key ? 180 : 0}
                          />
                        </div>
                      ) : null}
                    </div>

                    <Collapse in={openMenuIndex === key}>
                      {(menuOptions || []).map(subMenu => {
                        const {
                          key: subMenuId,
                          name: subMenuTitle,
                          isEnabled,
                        } = { ...subMenu };
                        const subMenuLink = `${ORG}/${organizationUuid}${get(
                          NAV_LINK_MAP,
                          subMenuId,
                        )}`;

                        if (!isEnabled)
                          return (
                            <ClickableComponent
                              key={subMenuId}
                              className={s.disabledSubMenuItem}
                              onClick={() => {
                                if (isMember) {
                                  showModal('ORG_ACCESS_BLOCKED');
                                }
                              }}
                            >
                              {subMenuTitle}
                              <div className={s.lockIcon}>
                                <FontAwesomeIcon icon={faLockKeyhole} />
                              </div>
                            </ClickableComponent>
                          );

                        if (subMenuLink) {
                          return (
                            <ClickableComponent
                              key={subMenuId}
                              to={subMenuLink}
                              className={s.subMenuItem}
                              onClick={() => {
                                this.goToRoute(subMenuLink);
                                toggleAppbar();
                              }}
                            >
                              {subMenuTitle}
                            </ClickableComponent>
                          );
                        }

                        return null;
                      })}
                    </Collapse>
                  </div>
                );
              })}
            {baseNav &&
              baseNav.items.map(menu => {
                const { key, name, menuOptions } = menu;
                const menuContext = get(MENU_ICON_MAP_ENH(user), key);
                const isMenuItemHidden = getHiddenNavItem({ menu });

                if (isMenuItemHidden) {
                  return null;
                }
                const isMenuActive = ensureArray(menuContext.routes).some(el =>
                  pathname.startsWith(el),
                );
                const isMenuActiveSpecialCondition = get(
                  menuContext,
                  'activeCondition',
                  () => null,
                )(match, pathname, isMenuActive);
                const MenuIcon = get(MENU_ICON_MAP, key);
                const link = get(MENU_ICON_LINK_MAP, key);
                if (!(menuOptions || []).length && link)
                  return (
                    <NavLink
                      key={key}
                      className={cn(s.menuItem, {
                        [s.activeMenuItem]:
                          isMenuActiveSpecialCondition !== null
                            ? isMenuActiveSpecialCondition
                            : isMenuActive,
                      })}
                      to={link}
                    >
                      <div className={s.menuItemChildren}>
                        <div className={s.flexCenter}>
                          <div className={s.menuIcon}>
                            <MenuIcon />
                          </div>
                          <div className={s.menuTitle}>{name}</div>
                        </div>
                      </div>
                    </NavLink>
                  );

                return (
                  <div
                    key={key}
                    className={cn(s.menuItem, {
                      [s.activeMenuItem]:
                        isMenuActiveSpecialCondition !== null
                          ? isMenuActiveSpecialCondition
                          : isMenuActive,
                    })}
                  >
                    <div
                      className={s.menuItemChildren}
                      {...((menuOptions || []).length
                        ? {
                            role: 'button',
                            tabIndex: 0,
                            onClick: () => this.toggleMenu(key),
                          }
                        : {})}
                    >
                      <div className={s.flexCenter}>
                        <div className={s.menuIcon}>
                          <MenuIcon />
                        </div>
                        <div className={s.menuTitle}>{name}</div>
                      </div>

                      {(menuOptions || []).length ? (
                        <div className={s.menuToggleIcon}>
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            rotation={openMenuIndex === key ? 180 : 0}
                          />
                        </div>
                      ) : null}
                    </div>

                    <Collapse in={openMenuIndex === key}>
                      {(menuOptions || []).map(subMenu => {
                        const {
                          key: subMenuId,
                          name: subMenuTitle,
                          isEnabled,
                          kriUuids,
                          hasIndividualKri,
                        } = { ...subMenu };
                        // this is same logic in desktop sidenav, need to consolidate into one selector function
                        let subMenuLink = get(NAV_LINK_MAP, subMenuId);
                        if (kriUuids) {
                          subMenuLink =
                            user.isStudent || !hasIndividualKri
                              ? `/key-readiness-indicators/tree/${kriUuids[0]}`
                              : `/key-readiness-indicators/${kriUuids[0]}`;
                        }
                        if (isEmpty(subMenuLink))
                          console.warn(
                            `${subMenuId} does not have mapping to any link in NAV_LINK_MAP, please add one in order for it to show up on the side nav`,
                          );

                        if (!isEnabled)
                          return (
                            <div
                              key={subMenuId}
                              className={s.disabledSubMenuItem}
                            >
                              {subMenuTitle}
                              <div className={s.lockIcon}>
                                <FontAwesomeIcon icon={faLockKeyhole} />
                              </div>
                            </div>
                          );

                        if (subMenuLink) {
                          return (
                            <ClickableComponent
                              key={subMenuId}
                              to={subMenuLink}
                              className={s.subMenuItem}
                              onClick={() => this.goToRoute(subMenuLink)}
                            >
                              {subMenuTitle}
                            </ClickableComponent>
                          );
                        }

                        return null;
                      })}
                    </Collapse>
                  </div>
                );
              })}
          </div>
        </Drawer>
      </>
    );
  }
}

MobileSideNav.propTypes = {
  ...ModalPropTypes,
  router: RouterPropTypes,
};

MobileSideNav.defaultProps = {
  ...ModalDefaultProps,
  router: undefined,
};
